export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5.84375" y="11.8457" width="20.3077" height="13.8462" rx="2.76923" stroke="black" strokeWidth="1.2" />
            <path
                d="M10.9251 11.8461V10.0324C10.9251 9.72377 10.7597 9.44494 10.5488 9.21956C9.56885 8.17202 9.82065 6.30762 12.3097 6.30762C15.079 6.30762 17.8482 6.30762 19.2328 6.30762C21.465 6.30762 22.8335 7.17125 21.6676 9.31619C21.5877 9.46318 21.5405 9.62676 21.5405 9.79407V11.8461"
                stroke="black"
                strokeWidth="1.2"
            />
            <path
                d="M26.577 14.6152H27.0578C27.8544 14.6152 28.5001 15.261 28.5001 16.0576C28.5001 16.8541 27.8544 17.4999 27.0578 17.4999H26"
                stroke="black"
                strokeWidth="1.2"
            />
            <path
                d="M5.42297 14.6152H4.9422C4.14563 14.6152 3.49988 15.261 3.49988 16.0576C3.49988 16.8541 4.14563 17.4999 4.9422 17.4999H6"
                stroke="black"
                strokeWidth="1.2"
            />
            <circle cx="12.1575" cy="22.4612" r="0.923077" fill="black" />
            <circle cx="9.6887" cy="22.4612" r="0.923077" fill="black" />
            <path d="M22.9219 17.8457V23.8457" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M21.5391 22.4619H24.3083" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    );
}
